<div class="template3 container" *ngIf="isUserLoggedIn && show" [class.myaccount-mob]="isMobile">
    <div class="account-block p-0">
        <div id="account-menu" class="p-0 account-block__content-section">
            <ul role="menu">
                <li tabindex="0" (keyup.enter)="navigateToMyAccount()" class="text-left" tabindex="0" role="menuitem" aria-label="navigate to my profile" (click)="navigateToMyAccount()">
                    {{'header.My Profile' | translate | translateKey}}
                </li>
                <li class="text-left" tabindex="0" attr.aria-label="{{'header.Logout'|translate|translateKey}}" (focusout)="showOrHideMyAccount('myAccountdDiv',false)" role="menuitem" (click)="logout()" (keyup.enter)="logout()">
                    {{'header.Logout' | translate | translateKey}}
                </li>
            </ul>
        </div>
    </div>
</div>